module.exports = __webpack_public_path__ + "img/motion-detector-md.4c116de0.svg";